require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./clients-weymouth-bid.json") })
        }
      }, "path---clients-weymouth-bid");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---clients-weymouth-bid!./.cache/json/clients-weymouth-bid.json
// module id = 1394
// module chunks = 231608221292675